export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/traveler-right.60d03c45-0babed.svg";